module.exports = __webpack_public_path__ + "img/graphic-high-five.5c217069.svg";